import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/sign/wechat',
  title: window.language['system.wechat.title'],
  component: dynamicWrapper(app, [import('./model'),import('../../Material/Material/model'),import('../../HomePage/model'),], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/System/Wechat/index.js